<ng-container *transloco="let t; read: 'entity-title'">
  <ng-container [ngSwitch]="libraryType">
    <ng-container *ngSwitchCase="LibraryType.Comic">
      <ng-container *ngIf="titleName !== '' && prioritizeTitleName; else fullComicTitle">
        {{titleName}}
      </ng-container>
      <ng-template #fullComicTitle>
        {{seriesName.length > 0 ? seriesName + ' - ' : ''}}
        <ng-container *ngIf="includeVolume && volumeTitle !== ''">
          {{Number !== LooseLeafOrSpecial ? (isChapter && includeVolume ? volumeTitle : '') : ''}}
        </ng-container>
        {{Number !== LooseLeafOrSpecial ? (isChapter ? t('issue-num') + Number : volumeTitle) : t('special')}}
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="LibraryType.ComicVine">
      <ng-container *ngIf="titleName !== '' && prioritizeTitleName; else fullComicTitle">
        {{titleName}}
      </ng-container>
      <ng-template #fullComicTitle>
        {{seriesName.length > 0 ? seriesName + ' - ' : ''}}
        <ng-container *ngIf="includeVolume && volumeTitle !== ''">
          {{Number !== LooseLeafOrSpecial ? (isChapter && includeVolume ? volumeTitle : '') : ''}}
        </ng-container>
        {{Number !== LooseLeafOrSpecial ? (isChapter ? t('issue-num') + Number : volumeTitle) : t('special')}}
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="LibraryType.Manga">
      <ng-container *ngIf="titleName !== '' && prioritizeTitleName; else fullMangaTitle">
        {{titleName}}
      </ng-container>
      <ng-template #fullMangaTitle>
        {{seriesName.length > 0 ? seriesName + ' - ' : ''}}
        <ng-container *ngIf="includeVolume && volumeTitle !== ''">
          {{Number !== LooseLeafOrSpecial ? (isChapter && includeVolume ? volumeTitle : '') : ''}}
        </ng-container>
        {{Number !== LooseLeafOrSpecial ? (isChapter ? (t('chapter') + ' ')  + Number : volumeTitle) : t('special')}}
      </ng-template>
    </ng-container>
    <ng-container *ngSwitchCase="LibraryType.Book">
      {{volumeTitle}}
    </ng-container>
    <ng-container *ngSwitchCase="LibraryType.LightNovel">
      {{volumeTitle}}
    </ng-container>
    <ng-container *ngSwitchCase="LibraryType.Images">
      {{Number !== LooseLeafOrSpecial ? (isChapter ? (t('chapter') + ' ')  + Number : volumeTitle) : t('special')}}
    </ng-container>
  </ng-container>
</ng-container>
